<script>
import IconMap from "@js/components/Icons/IconMap.vue";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";

export default {
    name: "SocialsListIcons",
    components: {IconWhatsApp, IconTelegram, IconMapPoint, IconMap},
    props: {
        classes: {
            type: String,
            default: 'w-5 h-5 text-white',
        },
        space: {
            type: String,
            default: 'space-x-4',
        }
    },
}
</script>

<template>
    <ul class="flex flex-row font-medium mt-0 text-sm" :class="[space]">
        <li>
            <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
               target="_blank" aria-label="WhatsApp" title="WhatsApp">
                <IconWhatsApp :class="[classes]"/>
            </a>
        </li>
        <li>
            <a href="https://t.me/Dorozhnyeplity" target="_blank"
               aria-label="Telegram" title="Telegram">
                <IconTelegram :class="[classes, '-ms-0.5']"/>
            </a>
        </li>
        <li>
            <a href="https://yandex.com/maps/-/CHqNiWk4" target="_blank" aria-label="Map" title="Map">
                <IconMapPoint :class="[classes]"/>
            </a>
        </li>
    </ul>
</template>

<style scoped lang="scss">

</style>
